<template>
    <div v-if="active" v-bind:style="{ backgroundColor: overLaycolor }"
         class="n2-loader-container">
        <div class="n2-loader-default"></div>
    </div>
</template>
<script>
    export default {
        name: 'Loader',
        props: ['overlay_color', 'active'],
        computed: {
            overLaycolor: function () {
                return this.overlay_color ? this.overlay_color : '#f1f1f1';
            }
        }
    }
</script>

